var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 32,
    viewBox: "0 0 102 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101 1C101 1 94.5884 14.125 89.75 14.125C84.9116 14.125 85.2359 17.875 81 17.875C76.7641 17.875 78.155 4.99092 76 6.6204C72.3603 9.37251 71.6088 19.7605 68.5 17.875C65.3912 15.9895 62.4149 8.4895 61 10.375C59.5851 12.2605 60.9628 13.1875 56 13.1875C51.0372 13.1875 51.4785 18.4884 49.75 21.625C48.0215 24.7616 41.7541 10.375 38.5 10.375C35.2459 10.375 29.9973 29.125 27.25 29.125C24.5027 29.125 24.528 27.25 22.25 27.25C19.972 27.25 19.2506 25.375 16 25.375C12.7494 25.375 10.9068 30.0601 8.5 30.0601C6.09315 30.0601 1 31 1 31H101V1Z",
    fill: "url(#paint0_linear_1295_970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 1C101 1 94.5884 14.125 89.75 14.125C84.9116 14.125 85.2359 17.875 81 17.875C76.7641 17.875 78.155 4.99092 76 6.6204C72.3603 9.37251 71.6088 19.7605 68.5 17.875C65.3912 15.9895 62.4149 8.4895 61 10.375C59.5851 12.2605 60.9628 13.1875 56 13.1875C51.0372 13.1875 51.4785 18.4884 49.75 21.625C48.0215 24.7616 41.7541 10.375 38.5 10.375C35.2459 10.375 29.9973 29.125 27.25 29.125C24.5027 29.125 24.528 27.25 22.25 27.25C19.972 27.25 19.2506 25.375 16 25.375C12.7494 25.375 10.9068 30.0601 8.5 30.0601C6.09315 30.0601 1 31 1 31",
    stroke: "#42A93C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_970",
    x1: 100.787,
    y1: 31,
    x2: 100.787,
    y2: 1.12769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A93C",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A93C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/P2.564cfa0f81574bc21d241af23f034116.svg";
export { ForwardRef as ReactComponent };